/**
 * COA print page — QR code + hide Shopify chrome before print.
 */
(function () {
  var CHROME_SELECTORS = [
    '#shopify-preview-bar',
    '#preview-bar-iframe',
    '#admin-bar-iframe',
    'iframe[name="preview-bar"]',
    '[class*="preview-bar"]',
    '[id*="preview-bar"]',
  ];

  var QR_SIZE = 280;

  function hidePrintChrome() {
    CHROME_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('data-coa-print-hidden', '');
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function restorePrintChrome() {
    document.querySelectorAll('[data-coa-print-hidden]').forEach(function (el) {
      el.removeAttribute('data-coa-print-hidden');
      el.style.removeProperty('display');
    });
  }

  function initCoaPrintQr(root) {
    var scope = root && root.querySelector ? root : document;
    var imgs = scope.querySelectorAll('[data-coa-print-qr]');

    imgs.forEach(function (img) {
      if (img.dataset.coaQrInitialized === 'true') return;

      var url = img.getAttribute('data-verify-url');
      if (!url) return;

      var qrSize = QR_SIZE;
      if (img.closest('.coa-mockup-modal')) {
        qrSize = 128;
      }

      function drawQr(attempt) {
        if (typeof window.QRCode === 'undefined') {
          if (attempt < 40) {
            window.setTimeout(function () {
              drawQr(attempt + 1);
            }, 100);
          }
          return;
        }

        window.QRCode.toDataURL(
          url,
          {
            margin: 1,
            width: qrSize,
            color: { dark: '#1a1a1a', light: '#f0ede8' },
          },
          function (err, dataUrl) {
            if (err) {
              console.warn('[coa-print] QR error', err);
              return;
            }
            img.src = dataUrl;
            img.removeAttribute('hidden');
            img.removeAttribute('width');
            img.removeAttribute('height');
            img.dataset.coaQrInitialized = 'true';
          }
        );
      }

      drawQr(0);
    });
  }

  window.initCoaPrintQr = initCoaPrintQr;

  window.addEventListener('beforeprint', hidePrintChrome);
  window.addEventListener('afterprint', restorePrintChrome);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCoaPrintQr(document);
    });
  } else {
    initCoaPrintQr(document);
  }
})();
